import { EntitiesSocketMessageData } from "./entities-socket-message-data";
import SocketMessage from "./socket-message";

/** When multiple entities have been added/edited */
export default class EntitiesMessage<T> extends SocketMessage<'entities'> {
    constructor(data: EntitiesSocketMessageData<T>) {
        global.executions.addLine({className: "EntitiesMessage",functionName: "[constructor]",hierarchy: ["/shared/socket/messages/entities-message.ts", "EntitiesMessage", "[constructor]"],fileName: "/shared/socket/messages/entities-message.ts",childLine: 7,line: "        super('entities', data)"});
        super('entities', data)
    }
}